import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { ApplicationLocale } from '../../common/model/application-locale.model';
import { resolveLocale } from '../../common/common';
import { WindowRef } from '../../common';

const supportedLocalesVA = [ApplicationLocale.en_US, ApplicationLocale.en_GB];
const supportedLocalesLC = [ApplicationLocale.es_US, ApplicationLocale.zh_CN];

@Injectable()
export class NeedHelpService {
  appConfig: IAppConfig;
  popupChat: any;

  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig, private _window: WindowRef) {
    this.appConfig = appConfig;
  };

  isVirtualAssistantSupported() {
    return this._isDefined() && supportedLocalesVA.indexOf(resolveLocale(this.appConfig)) >= 0;
  }

  isLiveChatSupported() {
    return supportedLocalesLC.indexOf(resolveLocale(this.appConfig)) >= 0;
  }

  openVirtualAssistant() {
    if (this._isDefined()) {
      return this._window.nativeWindow.IHG_CRO.VirtualAssistant.open();
    }
    return false;
  }

  private _isDefined() {
    return typeof this._window.nativeWindow.IHG_CRO !== 'undefined'
      && typeof this._window.nativeWindow.IHG_CRO.VirtualAssistant !== 'undefined'
      && typeof this._window.nativeWindow.IHG_CRO.VirtualAssistant.open === 'function';
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/need-help.service.ts